import React, { useContext, useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { fetchUsersProfile, updateProfileDetls } from '../shared/ApiEndpoint';
import { CurrentUserId, getInitials, StaticUploadPath } from '../shared/shared';
import axiosInstance from '../../utils/axiosInstance';
import { UserContext } from '../../utils/UserContext';
import { notification } from 'antd';

const ViewProfile = () => {


  const { updateUser } = useContext(UserContext);

  const [profile, setProfile] = useState({});
  const [originalProfile,setOriginalProfile]=useState({});

  const [imageError, setImageError] = useState(false);

  useEffect(()=>{
fetchUsers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageError(false);
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfile({ ...profile, profileUrl: imageUrl, selectedFile: file });
    }
  };

  const fetchUsers=async()=>{
    const res = await axiosInstance.get(
  `${fetchUsersProfile}/${CurrentUserId}`,
  { withCredentials: true }
);  
    if(res.status===200){
      const data=res.data;
     
    const profileData = {
      profileUrl: data.profile_image,
      username: data.username,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
    };

    setProfile(profileData);
    setOriginalProfile(profileData);
    
    // Store original values here
        updateUser({
          username: data.username,
          firstname: data.first_name,
          lastname: data.last_name,
          email: data.email,
          profile_image: data.profile_image
        });

                // Update local storage
        if (data.profile_image) {
          localStorage.setItem("profile_image", data.profile_image);
        }

    }
  }

    const hasProfileChanged = () => {
  return (
    profile.firstName !== originalProfile.firstName ||
    profile.lastName !== originalProfile.lastName ||
    profile.email !== originalProfile.email ||
    profile.selectedFile !== undefined
  );
};
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      user_id: CurrentUserId,
      username: profile.username,
      firstname: profile.firstName,
      lastname: profile.lastName,
      email: profile.email,
      profile_image: profile.selectedFile
    };

      if (!hasProfileChanged()) {
    notification.info({
      message: 'No changes made',
      placement: 'topRight',
    });
    return;
  }
    try {
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });

      const response = await axiosInstance.post(updateProfileDetls, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true
      });

      if (response.status === 200) {
        console.log("✅ Profile updated");
notification.success({
        key: 'channelcreate-success',
        description: 'Profile updated',
        placement: 'topRight',
      });

        const updatedProfile = {
          firstName: profile.firstName,
          lastName: profile.lastName,
          email: profile.email,
          profileUrl: profile.selectedFile ? profile.profileUrl :""
        };



        fetchUsers();

        // Update Context
      
        setProfile(prev => ({
          ...prev,
          ...updatedProfile
        }));
      }
    } catch (error) {
      console.error("❌ Update failed", error);
    }
  };

   const getProfileImageSrc = () => {
    if (profile.selectedFile) {
      return profile.profileUrl;
    }

    if (profile.profileUrl?.startsWith('http')) {
      return profile.profileUrl;
    }

    if (profile.profileUrl) {
      return `${StaticUploadPath}/${profile.profileUrl}`;
    }

    return ''; // fallback
  };




  return (
    <div className="container mt-5">
      <h3 className="mb-4">View / Edit Profile</h3>

    <div className="text-center mb-4">
        <div className="position-relative d-inline-block">
          {!imageError && profile.profileUrl ? (
            <img
              src={getProfileImageSrc()}
              alt="Profile"
              className="rounded-circle border"
              width="120"
              height="120"
              style={{ objectFit: 'cover' }}
              onError={() => setImageError(true)}
            />
          ) : (
            <div
              className="rounded-circle border bg-secondary text-white d-flex align-items-center justify-content-center"
              style={{ width: '120px', height: '120px', fontSize: '36px' }}
            >
              {getInitials(profile.username)}
            </div>
          )}

          <label
            htmlFor="profileUpload"
            className="btn btn-sm btn-dark position-absolute bottom-0 end-0 rounded-circle fs-5"
          >
            <EditIcon />
          </label>

          <input
            type="file"
            id="profileUpload"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: 'none' }}
          />
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className="mb-3 col-md-6">
            <label className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              value={profile.firstName}
              onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
            />
          </div>
          <div className="mb-3 col-md-6">
            <label className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              value={profile.lastName}
              onChange={(e) => setProfile({ ...profile, lastName: e.target.value })}
            />
          </div>
        </div>

        <div className='row'>
          <div className="mb-3 col-md-6">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-control"
              value={profile.username}
              disabled
            />
          </div>
          <div className="mb-3 col-md-6">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={profile.email}
              onChange={(e) => setProfile({ ...profile, email: e.target.value })}
            />
          </div>
        </div>

        <div className='d-flex justify-content-end'>
          <button type="submit" className="btn btn-primary">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default ViewProfile;
